import { Info } from 'lucide-react'

const InfoBox = ({ className = '', infoText = '' }) => {
  return (
    <div
      className={`bg-gray-100 mb-4 rounded-md flex gap-2 p-3 ${className}`}
    >
      <Info size={16} className="text-gray-500 shrink-0 mt-0.5" />
      <p className="text-body-xs text-gray-800">
        {infoText ||
          `We use this information to provide you with personalized health
        recommendations.`}
      </p>
    </div>
  )
}

export default InfoBox
